import { CodeSubject } from 'civil-status/constants/code-subject-section';

export const numberCondition = (
  numberHolders?: string,
  isFiglio?: boolean
): Array<string> | undefined => {
  if (!numberHolders) {
    return;
  }

  const res = [];

  let i = 0;
  while (i < Number.parseInt(numberHolders, 10)) {
    res.push(`${isFiglio ? CodeSubject.FIGLIO : CodeSubject.INT_NAS}_${i + 1}`);
    i++;
  }

  return res;
};
